module.exports = __webpack_public_path__ + "static/img/project/left-bar.png";